// Resizable two-panel split for the WorkHub Pathway manager: left editor column | right map/resolution column.
// Separate key from the legacy Page_PathwayEditor (min 600) so the editor column can start narrow (min 376).
export const workspaceKey_ManagerPathwayWorkHub = 'workspace__pathway-manager-workhub';
export const WorkspaceConfig_ManagerPathwayWorkHub = {
    name: workspaceKey_ManagerPathwayWorkHub,
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            // factor is applied on first render (min only clamps while dragging), so pick a factor
            // that starts the editor near ~376px on a typical KM workspace width.
            {
                name: 'EditorPanel', key: 'editorPanel', visible: true, factor: 2 / 5, min: 376,
                data: {}
            },
            {
                name: 'MapPanel', key: 'mapPanel', visible: true, factor: 3 / 5, min: 480,
                data: {}
            },
        ]
    }
};
//# sourceMappingURL=workspace-config.js.map